// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__2uCBd","section":"styles_section__1j3zq","heading":"styles_heading__1J1UV","count":"styles_count__1NOfF","participants":"styles_participants__1INbN"};